// -----------------  FETCH NPVR_RECORDINGS -----------------
export const FETCH_NPVR_RECORDINGS_LOADING = 'FETCH_NPVR_RECORDINGS_LOADING';
export const FETCH_NPVR_RECORDINGS_SUCCESS = 'FETCH_NPVR_RECORDINGS_SUCCESS';
export const FETCH_NPVR_RECORDINGS_ERROR = 'FETCH_NPVR_RECORDINGS_ERROR';

// -----------------  REMOVE_RECORDING_PER_DEVICE -----------------
export const REMOVE_NPVR_RECORDINGS_ITEM_ERROR =
	'REMOVE_NPVR_RECORDINGS_ITEM_ERROR';
export const REMOVE_NPVR_RECORDINGS_ITEM_LOADING =
	'REMOVE_NPVR_RECORDINGS_ITEM_LOADING';
export const REMOVE_NPVR_RECORDINGS_ITEM_SUCCESS =
	'REMOVE_NPVR_RECORDINGS_ITEM_SUCCESS';
export const CLEAR_NPVR_RECORDINGS_ERRORS = 'CLEAR_NPVR_RECORDINGS_ERRORS';

// ----------------- SCHEDULE_NPVR_RECORDING ----------------------
export const SCHEDULE_NPVR_RECORDING_LOADING =
	'SCHEDULE_NPVR_RECORDING_LOADING';
export const SCHEDULE_NPVR_RECORDING_ERROR = 'SCHEDULE_NPVR_RECORDING_ERROR';
export const SCHEDULE_NPVR_RECORDING_SUCCESS =
	'SCHEDULE_NPVR_RECORDING_SUCCESS';
